var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('file-pond',{ref:"pond",staticClass:"filepond",attrs:{"name":"gpxTrack","label-idle":"Trace GPX","allow-multiple":true,"max-files":"1","server":_vm.server},on:{"init":_vm.handleInit}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }